var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-action-button',{attrs:{"item":_vm.item,"hide-label":_vm.icon,"label":_vm.$t('clients.add_categories'),"icon":"mdi-clipboard-list","color":"primary","text":""},on:{"click":_vm.showAndAddCategories}})}
var staticRenderFns = []

export { render, staticRenderFns }